import calls from '@/backend/api-calls'

const state = () => ({
  elevations: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.elevations.map(d => d.id);
  }
}

// actions
const actions = {
  getElevations: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.elevations.get(parameters)
        .then(resp => {
          commit("setElevations", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addElevation: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.elevations.post(data)
        .then(resp => {
          commit("insertElevation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Elevation successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateElevation: ({commit}, { elevationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.elevation.put(elevationId, data)
        .then(resp => {
          commit("insertUpdatedElevation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Elevation successfully updated'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteElevation: ({commit}, elevationId) => {
    return new Promise((resolve, reject) => {
      calls.elevation.delete(elevationId)
        .then(resp => {
          commit("removeElevation", elevationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Elevation successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setElevations (state, data) {
    state.elevations = data.results;
    state.pagination = data.pagination;
  },
  insertElevation (state, data) {
    state.elevations.push(data);
  },
  insertUpdatedElevation (state, data) {
    state.elevations.forEach((elevation, i) => {
      if (elevation.id == data.id) {
        state.elevations.splice(i, 1, data);
      }
    })
  },
  removeElevation (state, id) {
    state.elevations.forEach((elevation, i) => {
      if (elevation.id == id) {
        state.elevations.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}